<template>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function () {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          },
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '200',
          max: '768',
          labelDesc: 'max-width-tablet',
          callback: function() {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';
          }
        },

        iconsEnable: {
          name: 'withRegards',
          defaultValue: '0',
          defaultOptions: [
            {
              name: 'icons-enable',
              value: '1'
            },
            {
              name: 'icons-disable',
              value: '0'
            }
          ],
          labelDesc: 'icon-enable',
          callback: function() {
            vm.resources.iconsEnable.defaultValue = this.value;
            vm.element.internal_config.iconsEnable = this.value;
          }
        },

        boxShadow: {
          name: 'boxShadow',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'tab-nav-box-shadow',
          callback: function() {
            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

            vm.resources.boxShadow.defaultValue = value;
            vm.element.internal_config.tabNav.boxShadow = value;
          }
        },

        border: {
          name: 'border',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'tab-nav-border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.tabNav.border = value;
          }
        },

        borderRadius: {
          name: 'borderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'tab-nav-borderRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.tabNav.borderRadius = value;
          }
        },

        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          labelDesc: 'tab-content-bg-color',
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.tabContent.backgroundColor = this.colorValue;
          }
        },

        // Styles
        tabNavTextStyle: {
          name: 'tabNavTextStyle',
          defaultFamily: '',
          defaultSize: '',
          showSizeMobile: true,
          shitOptions: true,
          defaultSizeMobile: '15px',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStroke: '',
          defaultStyle: '',
          labelDesc: 'tab-nav-textstyle',
          callback: function() {
            vm.setTextStyle('tabNav', 'tabNavTextStyle', this);
          }
        },

        tabContentTextStyle: {
          name: 'tabContentTextStyle',
          defaultFamily: '',
          defaultSize: '',
          showSizeMobile: true,
          shitOptions: true,
          defaultSizeMobile: '15px',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStroke: '',
          defaultStyle: '',
          labelDesc: 'tab-content-textstyle',
          callback: function() {
            vm.setTextStyle('tabContent', 'tabContentTextStyle', this);
          }
        },

        tabContentBoxShadow: {
          name: 'dropdownBoxShadow',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'tab-content-box-shadow',
          callback: function() {
            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

            vm.resources.tabContentBoxShadow.defaultValue = value;
            vm.element.internal_config.tabContent.boxShadow = value;
          }
        },

        tabContentBorder: {
          name: 'dropdownBorder',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'tab-content-border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.tabContentBorder.defaultValue = value;
            vm.element.internal_config.tabContent.border = value;
          }
        },

        tabContentBorderRadius: {
          name: 'dropdownBorderRadius', // border radius 2
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'tab-content-borderRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.tabContentBorderRadius.defaultValue = value;
            vm.element.internal_config.tabContent.borderRadius = value;
          }
        },

        backgroundTabColor: {
          name: 'backgroundTabColor',
          defaultValue: '#ffffff',
          labelDesc: 'tab-bg-color',
          callback: function() {
            vm.resources.backgroundTabColor.defaultValue = this.colorValue;
            vm.element.internal_config.tabNav.backgroundTabColor = this.colorValue;
          }
        },

        backgroundTabActiveColor: {
          name: 'backgroundTabActiveColor',
          defaultValue: '#ffffff',
          labelDesc: 'tab-active-bg-color',
          callback: function() {
            vm.resources.backgroundTabActiveColor.defaultValue = this.colorValue;
            vm.element.internal_config.tabNav.backgroundTabActiveColor = this.colorValue;
          }
        },

        backgroundTabHoverColor: {
          name: 'backgroundTabHoverColor',
          defaultValue: '#ffffff',
          labelDesc: 'tab-hover-bg-color',
          callback: function() {
            vm.resources.backgroundTabHoverColor.defaultValue = this.colorValue;
            vm.element.internal_config.tabNav.backgroundTabHoverColor = this.colorValue;
          }
        },

        textColorTabActive: {
          name: 'textColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'tab-text-active-color',
          callback: function() {
            vm.resources.textColorTabActive.defaultValue = this.colorValue;
            vm.element.internal_config.tabNav.textColorTabActive = this.colorValue;
          }
        }

      }
    };
  },
  methods: {

    setTextStyle(type, resourceName, config) {
      let vm = this;

      this.resources[resourceName] = Object.assign({}, vm.resources[resourceName], {
        defaultFamily: config.family,
        defaultSize: config.size + 'px',
        defaultSizeMobile: config.sizeMobile + 'px',
        defaultColor: config.color,
        defaultAlign: config.align,
        weight: config.weight,
        defaultStyle: config.style,
        defaultStroke: config.stroke
      });

      this.element.internal_config[type].textStyle = Object.assign({}, vm.element.internal_config[type].textStyle, {
        family: config.family,
        size: config.size + 'px',
        sizeMobile: config.sizeMobile + 'px',
        color: config.color,
        align: config.align,
        weight: config.weight,
        style: config.style,
        stroke: config.stroke
      });
    },

    setResourceTextStyle(resourceName, textStyle) {
      this.resources[resourceName].defaultFamily = textStyle.family;
      this.resources[resourceName].defaultSize = textStyle.size;
      this.resources[resourceName].defaultSizeMobile = textStyle.sizeMobile;
      this.resources[resourceName].defaultColor = textStyle.color;
      this.resources[resourceName].defaultAlign = textStyle.align;
      this.resources[resourceName].defaultWeight = textStyle.weight;
      this.resources[resourceName].defaultStyle = textStyle.style;
      this.resources[resourceName].defaultStroke = textStyle.stroke;
    },

    setValuesData(data) {
      this.element = data;

      this.setResourceTextStyle('tabNavTextStyle', data.internal_config.tabNav.textStyle);
      this.setResourceTextStyle('tabContentTextStyle', data.internal_config.tabContent.textStyle);

      if (data.internal_config.iconsEnable) { this.resources.iconsEnable.defaultValue = data.internal_config.iconsEnable }

      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

      this.resources.border.defaultValue = data.internal_config.tabNav.border;
      this.resources.borderRadius.defaultValue = data.internal_config.tabNav.borderRadius;
      this.resources.boxShadow.defaultValue = data.internal_config.tabNav.boxShadow;

      this.resources.tabContentBorder.defaultValue = data.internal_config.tabContent.border;
      this.resources.tabContentBorderRadius.defaultValue = data.internal_config.tabContent.borderRadius;
      this.resources.tabContentBoxShadow.defaultValue = data.internal_config.tabContent.boxShadow;

      this.resources.backgroundColor.defaultValue = data.internal_config.tabContent.backgroundColor;

      this.resources.backgroundTabColor.defaultValue = data.internal_config.tabNav.backgroundTabColor;
      this.resources.backgroundTabActiveColor.defaultValue = data.internal_config.tabNav.backgroundTabActiveColor;
      this.resources.backgroundTabHoverColor.defaultValue = data.internal_config.tabNav.backgroundTabHoverColor;
      this.resources.textColorTabActive.defaultValue = data.internal_config.tabNav.textColorTabActive;
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Members/ContentNavUser/Resources.vue